var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-form-group',{attrs:{"label-for":"metrics-select","label":_vm.$t('keyResult.metrics.metric')}},[_c('Select',{attrs:{"id":"metrics-select","state":_vm.state,"selected":_vm.value,"options":_vm.options},on:{"changeValue":_vm.emitUpdateEvent}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }